import React from 'react';
import { useTranslation } from 'react-i18next';
import PageBanner from '../layout/PageBanner';
import AboutUsContent from '../components/AboutUsContent';
import CounterBlog from '../components/CounterBlog';
import WithUs from '../components/WithUs';
import TestimonialBlog from '../components/TestimonialBlog';
import TouchStart from '../components/TouchStart';
import StoryBlog from '../components/StoryBlog';
import ServiceArea from '../element/ServiceArea';
import TeamSection from "../element/TeamSection";


const AboutUs = () => {
    const { t } = useTranslation();
    return (
        <>
            <PageBanner parentPage={t('aboutUsPage.parentPage')} activePage={t('aboutUsPage.activePage')} motherMenu={t('aboutUsPage.motherMenu')} />

            {/* 1. Hero + Why Choose + Mission/Vision */}
            <section className="main-about-us">
                <AboutUsContent />
            </section>

            {/* 2. Stats counters */}
            <div className="main-counter">
                <CounterBlog />
            </div>

            {/* 3. Our Story timeline */}
            <section className="main-story">
                <StoryBlog />
            </section>

            {/* 4. Meet the team */}
            <section className="main-team" style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
                <TeamSection />
            </section>

            {/* 5. CTA banner */}
            <section className="main-with-us">
                <WithUs />
            </section>

            {/* 6. Service areas */}
            <section className="main-service-area" style={{ padding: '80px 0' }}>
                <ServiceArea />
            </section>

            {/* 7. Testimonials */}
            <section className="main-testimonial mb-2">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title">{t('aboutUsPage.testimonialSubtitle')}</span>
                                <h2 className="h2-title">{t('aboutUsPage.testimonialTitle')}</h2>
                            </div>
                        </div>
                    </div>
                    <TestimonialBlog />
                </div>
            </section>

            {/* 8. Contact form — final CTA */}
            <section className="main-contact page-inner-contact">
                <div className="container">
                    <TouchStart />
                </div>
            </section>
        </>
    );
};

export default AboutUs;